import errorMessages from "./errorMessages"

export const getErrorMessage = function (error) {
  if (error && error.response && error.response.data && error.response.data.message) {
    return error.response.data.message
  }
  return errorMessages.COMMON_ERROR_MESSAGE
}
